import { isMobile } from "react-device-detect"
import { imagenesAll } from "../asset/img"
import { IsPcHeader } from "../componentes/Principales"
import { useEffect } from "react"

export const NotFound =()=>{
  return(
    <>
      {isMobile ? <NotFoundMobile /> : <NotFoundDesktop />}
    </>
  )
}

export const NotFoundDesktop  =()=>{
    useEffect(() => {
      document.title = "WAZ - not Found";
    }, []);
  return(
    <div className="m_h100vh w-100 ">
      <IsPcHeader imgUrlWaz={imagenesAll.logoWazBordo} />
      <div className="w-100 h-75 m_dfc flex-column m_text_secondary">
        <span className="m_h1 m_tl">Error 404</span>
        <p className="w-25 text-center fs-6 m_bl mt-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
          tempor incididunt ut labore et dolore magna aliqua. "</p>
      </div>
    </div>
  )
}

export const NotFoundMobile  =()=>{
  return(
    <div className="w-100 m_h100vh m_dfc">404 not found</div>
  )
}